import AccountMapper from "@/features/account/infra/mapper/account.mapper";
import { AppUser } from "../../application/domain/entities/account";
import {AppUserDtoResponse} from "../dto/appUser.res.dto";

export default class AppUserMapper {
    static mapAppUserDtoToAppUser(accountDto: AppUserDtoResponse): AppUser {
        return new AppUser(
            accountDto.appUserId,
            accountDto.accountId,
            accountDto.email,
            accountDto.firstName,
            accountDto.lastName,
            accountDto.contactPhone,
            accountDto.jobTitle,
            accountDto.vtAppRole,
            accountDto.account ? AccountMapper.mapAccountDtoToAccount(accountDto.account) : null,
        );
    }
}